// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__-K4EC","detailsBorder":"styles_detailsBorder__1f6kk"};